import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://10.62.55.108:8001",
});

export default api;
